/**
 * Bavlio Inc.'s brands since Oct 18 2026: Rosefall is the done-for-you agency (rosefall.ai), Bavlio the outreach
 * software and Bavimail the email platform. The same family line is in the footer of every site of the three, as
 * plain followed links (Bavi repo, seo-aeo `references/rosefall-page-format.md`, RF-10).
 */
export const BRAND_FAMILY = [
  { name: "Rosefall", href: "https://rosefall.ai/", what: "the agency" },
  { name: "Bavlio", href: "https://bavlio.com/", what: "outreach software" },
  { name: "Bavimail", href: "https://bavimail.com/", what: "email platform" },
] as const;

export function BrandFamilyLine({
  className,
  linkClassName,
}: {
  className?: string;
  linkClassName?: string;
}) {
  return (
    <p className={className}>
      From Bavlio Inc.:{" "}
      {BRAND_FAMILY.map((brand, i) => (
        <span key={brand.name}>
          {i > 0 ? " · " : null}
          <a href={brand.href} className={linkClassName}>
            {brand.name}
          </a>
          , {brand.what}
        </span>
      ))}
    </p>
  );
}
